import { IconScaleStars } from '@presentation/components/IconScaleStars';
import { PLACEHOLDER_IMAGE_USER } from '@presentation/constants';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import * as Styled from '../styled';
import type { EducatorReviewItemData } from '../types';

export const ReviewItem: FC<EducatorReviewItemData> = (props) => {
  const { average, date, description, image, name, verified } = props;
  const { translate } = useTranslation();

  return (
    <>
      <Styled.ItemWrapper>
        <Styled.ItemImage
          src={image ?? PLACEHOLDER_IMAGE_USER}
          alt="reviewer profile image"
          // eslint-disable-next-line no-return-assign
          onError={(e) => ((e.target as any).src = PLACEHOLDER_IMAGE_USER)}
        />
        <div>
          <Styled.ItemHeader>
            <span>{name}</span>
            <span>
              <IconScaleStars amount={average ?? 0} />
            </span>
          </Styled.ItemHeader>
          <Styled.ItemDescription>{description}</Styled.ItemDescription>
          <Styled.ItemFooter>
            <span>{date}</span>
            {true && (
              <Styled.ItemVerified data-data-tooltip-content={translate('glossary.verifiedBuyer')}>
                <FaCheckCircle />
              </Styled.ItemVerified>
            )}
          </Styled.ItemFooter>
        </div>
      </Styled.ItemWrapper>
    </>
  );
};
